import { render, staticRenderFns } from "./MainFooter.vue?vue&type=template&id=a8d3077e&scoped=true&"
import script from "./MainFooter.vue?vue&type=script&lang=ts&"
export * from "./MainFooter.vue?vue&type=script&lang=ts&"
import style0 from "./MainFooter.vue?vue&type=style&index=0&id=a8d3077e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d3077e",
  null
  
)

export default component.exports